import { Component, OnInit, ViewChild } from '@angular/core';
import { ServicePathsSettings } from "../../../../core/configuration/service-paths-settings";
import { HelpersService } from "../../../../core/services/helpers.service";
import { OperationsService } from "../../../../core/services/operations.service";
import { RicercaAnagraficheFormComponent } from "../../../form/ricerca-anagrafiche-form.component";
import { Atto } from "../../../models/atto";
import { Classificazione } from "../../../models/classificazione";
import { Controparte } from "../../../models/controparte";
import { Fascicolo } from "../../../models/fascicolo/fascicolo";
import { Parte } from "../../../models/parte";
import { Pratica } from "../../../models/pratica/pratica";
import { ClassificazioneSezione } from "../../../models/sezioni/classificazione-sezione";
import { SezioneAttiFull } from "../../../models/sezioni/sezione-atti-full";
import { SezioneControparti } from "../../../models/sezioni/sezione-controparti";

declare var closeModal;

@Component({
    selector: 'app-creazione-rapida',
    templateUrl: './creazione-rapida.component.html',
    styleUrls: ['./creazione-rapida.component.css']
})
export class CreazioneRapidaComponent implements OnInit {

    constructor(private helpers: HelpersService, private service: OperationsService) {
    }

    pratica: Pratica;
    tipiPratica = [];
    tipiFascicolo = [];
    sezioneClassificazione: ClassificazioneSezione;
    classificazione: Classificazione;
    soggetti = [];
    materie = [];
    oggetti = [];
    argomenti = [];
    fascicolo: Fascicolo;
    tipiNatura = [];
    gradi = [];
    autoritaGiudiziarie = [];
    cittaPerAutoritaGiudiziaria = [];
    sezioneControparti: SezioneControparti;
    controparte: Controparte;
    @ViewChild('ricercaControparte', {static: true}) ricercaControparte: RicercaAnagraficheFormComponent<Parte>;
    sezioneAtti: SezioneAttiFull;
    atto: Atto;
    tipiAtto = [];
    tipiProvenienza = [];
    idFormPratica: string;


    ngOnInit() {
        this.reset();
        this.helpers.getTipiPratica().subscribe(response => this.tipiPratica = response);
        this.helpers.getSoggetti().subscribe(response => this.soggetti = response);
        this.helpers.getMateria().subscribe(response => this.materie = response);
        this.helpers.getTipiNatura().subscribe(response => this.tipiNatura = response);
        this.helpers.getGradi().subscribe(response => this.gradi = response);
        this.helpers.getAutoritaGiudiziarie().subscribe(response => this.autoritaGiudiziarie = response);
        this.ricercaControparte.inizializza(ServicePathsSettings.URL_SEARCH_PARTE, true);
        this.helpers.getTipiAtto().subscribe(response => this.tipiAtto = response);
        this.helpers.getTipiProvenienza().subscribe(response => this.tipiProvenienza = response);
    }

    annulla(){
        this.reset();
        closeModal('modaladdpraticaveloce');
    }

    reset(){
        this.pratica = new Pratica();
        this.sezioneClassificazione = new ClassificazioneSezione();
        this.sezioneClassificazione.classificazioni = [];
        this.classificazione = new Classificazione();
        this.fascicolo = new Fascicolo();
        this.fascicolo.flagFondoRischi = false;
        this.ricercaControparte.setTextEmpty();
        this.ricercaControparte.msgEmpty = "";
        this.sezioneControparti = new SezioneControparti();
        this.controparte = new Controparte();
        this.controparte.ritirato = false;
        this.sezioneAtti = new SezioneAttiFull();
        this.atto = new Atto();
    }

    setTipoPratica(selected) {
        this.pratica.tipoPratica = selected;
        if (selected){
            this.helpers.getTipiFascicolo(selected.id).subscribe(response => this.tipiFascicolo = response);
            this.service.getFormTenantByTipoPratica(selected.id).subscribe(response => {
                this.idFormPratica = response && response.idFormTenant ? response.idFormTenant : '';
            });
        } else {
            this.idFormPratica = '';
            this.tipiFascicolo = [];
        }
    }

    materiaChange(event) {
        this.classificazione.materia = event;
        this.classificazione.oggetto = null;
        this.classificazione.argomento = null;
        if (event) {
            this.helpers.getOggetti(event.id).subscribe(response => this.oggetti = response);
        } else {
            this.oggetti = [];
            this.argomenti = [];
        }
    }

    oggettoChange(event) {
        this.classificazione.oggetto = event;
        this.classificazione.argomento = null;
        if (event) {
            this.helpers.getArgomenti(this.classificazione.materia.id, event.id).subscribe(response => this.argomenti = response);
        } else {
            this.argomenti = [];
        }
    }

    addClassificazione() {
        if (this.classificazione.isPrincipale) {
            for (let classificazione of this.sezioneClassificazione.classificazioni) {
                classificazione.isPrincipale = false;
            }
        } else if (!this.sezioneClassificazione.classificazioni.length) {
            this.classificazione.isPrincipale = true;
        }
        this.sezioneClassificazione.classificazioni.push(Object.assign({}, this.classificazione));
        this.classificazione = new Classificazione();
    }

    removeClassificazione(index: number) {
        this.sezioneClassificazione.classificazioni.splice(index, 1);
    }

    /*
    autoritaGiudiziariaChange(event){
        this.fascicolo.autoritaGiudiziaria = event;
        this.fascicolo.autoritaGiudiziariaCitta = null;
        if(event){
            this.helpers.getCittaPerAutoritaGiudiziaria(event.id).subscribe(response => this.cittaPerAutoritaGiudiziaria = response);
        } else {
            this.cittaPerAutoritaGiudiziaria = [];
        }
    }
    */

    selezionaControparte(parte: Parte){
        this.controparte.parte = parte;
        this.ricercaControparte.setTextEmpty();
        this.ricercaControparte.msgEmpty = "";
    }

    isClassificazioneAlreadyPresent(newClassificazione: Classificazione): boolean {
        let present: boolean = false;
        if (this.sezioneClassificazione && this.sezioneClassificazione.classificazioni) {
          for (let classificazione of this.sezioneClassificazione.classificazioni) {
            if (this.createStringaTipoClassificazione(classificazione) == this.createStringaTipoClassificazione(newClassificazione)) {
              present = true;
            }
          }
        }
        return present;
      }

      createStringaTipoClassificazione(classificazione: Classificazione) {
        if (!classificazione) {
          return 'NonDisponibileNonDisponibileNonDisponibile';
        }
        return (classificazione.materia && classificazione.materia.id ? classificazione.materia.id : 'NonDisponibile') +
               (classificazione.oggetto && classificazione.oggetto.id ? classificazione.oggetto.id : 'NonDisponibile') +
               (classificazione.argomento && classificazione.argomento.id ? classificazione.argomento.id : 'NonDisponibile');
      }

    aggiungiControparte(){
        this.sezioneControparti.controparti.push(Object.assign({}, this.controparte));
        this.controparte.parte = null;
    }

    rimuoviControparte(index){
        this.sezioneControparti.controparti.splice(index, 1);
    }

    aggiungiAtto(){
        this.sezioneAtti.atti.push(Object.assign({}, this.atto));
        this.atto = new Atto();
    }

    rimuoviAtto(index){
        this.sezioneAtti.atti.splice(index, 1);
    }

    get isValid(): boolean {
        return !!this.pratica.tipoPratica &&
               !!this.pratica.soggetto &&
               !!this.fascicolo.tipoFascicolo &&
               !!this.fascicolo.dataInizioFascicolo &&
               !!this.fascicolo.natura &&
               !!this.sezioneClassificazione.classificazioni.length &&
               !!this.sezioneControparti.controparti.length;
    }

    salva(){
        const request = {
            classificazione: this.sezioneClassificazione,
            pratica: this.pratica,
            fascicoli: [
                Object.assign(this.fascicolo, {
                    sezioneControparti: this.sezioneControparti,
                    sezioneAtti: this.sezioneAtti
                })
            ]
        };
        this.service.inserimentoPraticaVeloce(request).subscribe(() => closeModal('modaladdpraticaveloce'));
    }

}
